/* eslint-disable */
import PropTypes from 'prop-types';
import {
  ORDER_STATUS_CANCELLED,
  ORDER_STATUS_COMPLETED,
  ORDER_STATUS_CONFIRMED,
  ORDER_STATUS_DELIVERING,
  ORDER_STATUS_NONE,
  ORDER_STATUS_ON_HOLD,
  ORDER_STATUS_TO_BE_CONFIRMED,
} from '../../Constants/Order/Order.constants';
import OrderEntityPropTypes from '../../Services/Order/Order.service.props';
import ThemeStatePropTypes from '../../State/Store/Theme/Theme.props';

const OrderQuantityPropTypes = {
  /**
   * The JSS classes to use
   */
  classes: ThemeStatePropTypes.classes.isRequired,

  /**
   * The order quantity
   */
  quantity: OrderEntityPropTypes.quantity,

  /**
   * The status code for the Order
   */
  status: PropTypes.oneOf([
    ORDER_STATUS_CANCELLED,
    ORDER_STATUS_COMPLETED,
    ORDER_STATUS_CONFIRMED,
    ORDER_STATUS_DELIVERING,
    ORDER_STATUS_NONE,
    ORDER_STATUS_ON_HOLD,
    ORDER_STATUS_TO_BE_CONFIRMED,
  ]),

  /**
   * The JSS theme to use
   */
  theme: ThemeStatePropTypes.theme.isRequired,
};

export default OrderQuantityPropTypes;
